import { Button, Select } from '@piggytechng/component-library';
import { useEffect, useState } from 'react';
import { OverideButtonStyle, OverideSelectStyle } from '../../../../helpers/utils';
import useCustomers from '../../../../hooks/useCustomers';
import ModalExecuteAction from '../../../../components/Modals/ModalExecuteAction';
import { localStorageEnum } from '../../../../api/enums';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { setModalActions } from '../../../../store/slices/utils';

export default function FlagManager({ UserId }: any) {
  const [flagTab, setFlagTab] = useState<'flag' | 'unflag'>('flag');
  const [reason, setReason] = useState('');
  const [flagType, setFlagType] = useState('freeze');
  const [showModal, setShowModal] = useState(false);
  const { isRunningUserAction, flagUser, unflagUser } = useCustomers();
  const modalActions = useSelector((state: RootState) => state.modalActions);
  const dispatch = useDispatch();

  const style = { ...OverideSelectStyle, style: { ...OverideSelectStyle.style, zIndex: undefined } };

  const userName = `${localStorage.getItem(localStorageEnum['local.storage.firstName'])} ${localStorage.getItem(localStorageEnum['local.storage.lastName'])}`;

  useEffect(() => {
    setReason('');
  }, [flagTab]);

  const resetForm = () => {
    setReason('');
    setFlagType('freeze');
    setShowModal(false);
  };

  return (
    <div className="flag-manager">
      <div className="flag-manager__tabs">
        <div
          className={flagTab === 'flag' ? 'active' : ''}
          onClick={() => {
            !isRunningUserAction && setFlagTab('flag');
          }}
        >
          Flag Account
        </div>
        <div
          className={flagTab === 'unflag' ? 'active' : ''}
          onClick={() => !isRunningUserAction && setFlagTab('unflag')}
        >
          Unflag Account
        </div>
      </div>

      <div className="flag-manager__content">
        {flagTab === 'flag' && (
          <Select
            label="Flag Type"
            {...style}
            labelStyle={{ color: '#666766' }}
            backgroundColor="#F9FAFB"
            outlineColor="none"
            height="60px"
            placeholder="Select flag type"
            value={flagType}
            onChange={(val: any) => setFlagType(val)}
            key={reason}
            options={[
              { value: 'sameDebitCardInUse', label: 'sameDebitCardInUse' },
              { value: 'multiplebvnmatch', label: 'Multiple BVN match' },
              { value: 'bvnnamenomatch', label: 'BVN Name No Match' },
              { value: 'transferfraud', label: 'Potential Transfer Fraud' },
              { value: 'toomanycoretransactions', label: 'Too Many Core Transaction' },
              { value: 'largevaluecoretransactions', label: 'Large Core Transaction Value Before Withdrawal' },
              { value: 'freeze', label: 'User Freeze Request' },
              { value: 'admin', label: 'Admin Blacklisted' },
              { value: 'double', label: 'Double Transactions Found' },
              { value: 'toomanygrouptransactions', label: 'Too Many Group Transactions' },
              { value: 'multipleaccountmatchflag', label: 'Multiple Account Match Flag' },
              { value: 'member_flagged_targets', label: 'Flagged Targets' },
              { value: 'doubletargetwithdrawal', label: 'Multiple Target Withdrawals' },
              { value: 'underinvestigation', label: 'Under Investigation' },
            ]}
          />
        )}
        <div className="reason-field">
          <p>Flag Reason</p>
          <textarea
            name="flag-reason"
            placeholder="Enter flag reason"
            rows={4}
            cols={50}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>

        <Select
          label={flagTab === 'flag' ? 'Flagged By' : 'Unflagged By'}
          {...style}
          labelStyle={{ color: '#666766' }}
          backgroundColor="#F9FAFB"
          outlineColor="none"
          height="60px"
          placeholder=""
          value={userName}
          key={reason + flagType}
          style={{
            pointerEvents: 'none',
          }}
          options={[
            {
              value: userName,
              label: userName,
            },
          ]}
        />

        <div className="flag-manager__content__actions">
          <Button
            type="submit"
            {...OverideButtonStyle}
            disabled={isRunningUserAction}
            style={{
              fontFamily: 'Jakarta',
              color: '#212337',
              flex: 1,
              margin: '10px 0 20px',
            }}
            color="#F7F7F7"
          >
            Cancel
          </Button>

          <Button
            type="submit"
            {...OverideButtonStyle}
            loading={isRunningUserAction}
            style={{
              fontFamily: 'Jakarta',
              flex: 1,
            }}
            onClick={() => setShowModal(true)}
          >
            {flagTab === 'flag' ? 'Flag Account' : 'Unflag Account'}
          </Button>
        </div>
      </div>

      <ModalExecuteAction
        modalIsOpen={showModal}
        setIsOpen={(state: boolean) => {
          setShowModal(state);
          if (!state) {
            dispatch(setModalActions({ ...modalActions, password: '' }));
          }
        }}
        action={(password: string) => {
          const payload = {
            ...(flagTab === 'flag' ? { reason, flag: flagType } : {}),
            password,
          };
          if (flagTab === 'flag') {
            flagUser(UserId, payload, () => resetForm());
          } else {
            unflagUser(UserId, payload, () => resetForm());
          }
        }}
        text={flagTab === 'flag' ? 'flag this user?' : 'unflag this user?'}
        actionColor={'#1734ca'}
        isLoading={isRunningUserAction}
      />
    </div>
  );
}
